import chatModule from "./type";

const getters = {
    // conversationsAll
    [chatModule.getters.conversations.userIds]: state => {
        return state.conversations.all
            .map(e => { return (e.interlocutor && e.interlocutor.id) })
            .filter(e => e)
    },
    [chatModule.getters.typingEnabled]: state => (userId, eventId) => {
        let key = !eventId ?  userId :  userId + '_' + eventId ;
        //console.log('[TypingEnabled]',key,state.usersTyping[key])
        return !!state.usersTyping[key]
            && !!state.usersTyping[key]['date'] && moment(new Date(),'YYYY-MM-DD HH:mm:ss').diff(state.usersTyping[key]['date'], 'seconds') < 7
    },
    // current user unread messages summ
    [chatModule.getters.general.unreadConversationsIds]: state => {
        return state.unreadConversationsIds
    },
    [chatModule.getters.conversations.cursor]: state => (conversationId) => {
      return conversationId in state.cursors ? state.cursors[conversationId] : '';
    },
    [chatModule.getters.general.unreadConversationsIds]: state => {
      return state.unreadConversationsIds
    },
    // conversationsAll
    [chatModule.getters.conversations.all]: state => {
        return state.conversations.all || []
    },
    // conversationsUnread
    [chatModule.getters.conversations.unread]: state => {
        return state.conversations.unread || []
    },
    // conversationsFavorites
    [chatModule.getters.conversations.favorites]: state => {
        return state.conversations.favorites || []
    },
    [chatModule.getters.conversations.chats]: state => {
        return state.conversations.chats || []
    },
    [chatModule.getters.conversations.clubs]: state => {
        return state.conversations.clubs || []
    },
    [chatModule.getters.conversations.loadingChats]: state => {
        return state.loadingChats || []
    },
    [chatModule.getters.replies.get]: state => (chatMode, userId, eventId) => {
        let id = chatMode + '-' + (['user','event'].includes(chatMode) ? userId : '') + (['group','event'].includes(chatMode) ? (['event'].includes(chatMode) ? ('-' + eventId) : eventId) : '')

        return id in state.replies ? state.replies[id] : false;
    },
    // unreadMessagesCount
    [chatModule.getters.messages.count.unread]: state => (userId) => {
        let conversation = state.conversations.all.find(el => el.chatType === 'user' && el.interlocutor.id == userId);
        return (conversation && conversation.unreadMessagesCount) ?
            conversation.unreadMessagesCount
            :
            '';
    },
    [chatModule.getters.lastTypeEvent]: state => (key) => {
        return state.typeEvents[key] !== undefined ? state.typeEvents[key] : false;
    },
    // unreadEventMessagesCount
    [chatModule.getters.messages.count.unreadEvent]: state => (eventId, userId) => {
        return state.conversations.all.reduce((accumulator, conversation) => {
            if (
                conversation.chatType === 'event'
                &&
                conversation.event.id == eventId
                &&
                (!!userId ? conversation.interlocutor.id == userId : true)
            ) {
                return accumulator + conversation.unreadMessagesCount
            } else {
                return accumulator
            }
        }, 0);
    },
}

export default getters
